
  export default {
    name: 'FeaturesCardList',
    props: {
      slice: {
        type: Object,
        required: true,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        success: this.$route.query.success || false,
        form: {
          full_name: '',
          company: '',
          email: '',
          title: '',
        },
        formValidation: {
          full_name: 'required|name',
          email: 'required|email',
          company: 'required|company',
          title: 'alpha_spaces',
        },
      }
    },
    computed: {
      featureCards() {
        return this.slice.items.map((item) => {
          const title = this.$prismic.asText(item.title)
          return {
            title: title,
            icon: item.icon,
            alt: item.icon.alt,
            description: item.description,
            link: item.link,
          }
        })
      },
    },
  }
